import { Routes, Route, useLocation, Navigate } from "react-router-dom";
import "./App.css";
import Sidenav1 from "./Component/sidenav";
import Overview from "./Component/Overview";
import Login from "./Component/Login";
import Signup from "./Component/Signup";
import AddProduct from "./Component/AddProduct";
import ProductView from "./Component/ProductView";
import Order from "./Component/Order";
import CouponComponent from "./Component/Coupon";
import OrderView from "./Component/OrderView";
import ClientProfile from "./Component/users.js";
import PrivateRoute from "./PrivateRoutes";
import ContactDetails from "./Component/Client.js";
import useAutoLogout from "./context/useAutoLogout.jsx";
import Layout from "./Layout/layout.jsx";
import Category from "./Component/Category.jsx";
import UserDetails from "./Component/users.js";
import Subscribe from "./Component/Subscribe.js";

export default function App() {
  const location = useLocation();
  const userData = JSON.parse(localStorage.getItem("userData"));
  useAutoLogout(!!userData);

  return (
    <Routes>
    
      <Route path="/" element={<Login />} />
      <Route path="/Signup" element={<Signup />} />

     
      {userData ? (
        <Route element={<PrivateRoute><Layout /></PrivateRoute>}>
          <Route path="/dashboard" element={<Overview />} />
          <Route path="/product" element={<AddProduct />} />
          <Route path="/viewdetails" element={<ProductView />} />
          <Route path="/order" element={<Order />} />
          <Route path="/orderview/:data" element={<OrderView />} />
          <Route path="/client" element={<ContactDetails />} />
          <Route path="/clientProfile/:data" element={<ClientProfile />} />
          <Route path="/coupon" element={<CouponComponent />} />
          <Route path="/category" element={<Category />} />
          <Route path="/users" element={<UserDetails/>} />
          <Route path="/subscribers" element={<Subscribe/>} />
        </Route>
      ) : (
        <Route path="*" element={<Navigate to="/" />} />
      )}
    </Routes>
  );
}